import { memo, useCallback } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';

import { handleAddIndicator } from 'redux/PlannerModeSlice';

import { BUILDER_MODE_V1_TOKENS } from '../constants';
import PlusIndicatorIcon from '../icons/assets/PlusIndicatorIcon';

const AddIndicatorTableFooterV1 = memo(() => {
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    dispatch(handleAddIndicator(false));
    requestAnimationFrame(() => {
      dispatch(handleAddIndicator(true));
    });
  }, [dispatch]);

  return (
    <Flex
      as='button'
      type='button'
      aria-label='Add new indicator'
      w='100%'
      h='34px'
      minH='34px'
      align='center'
      justify='center'
      gap='8px'
      flexShrink={0}
      className='builder-mode-v1-add-indicator-footer'
      bg={BUILDER_MODE_V1_TOKENS.white}
      border='1px solid'
      borderColor={BUILDER_MODE_V1_TOKENS.border}
      borderRadius='16px'
      cursor='pointer'
      onClick={handleClick}
      _hover={{ bg: BUILDER_MODE_V1_TOKENS.activeBg }}
      _active={{ bg: BUILDER_MODE_V1_TOKENS.activeBg }}
    >
      <PlusIndicatorIcon />
      <Text
        fontSize='14px'
        fontWeight='500'
        color={BUILDER_MODE_V1_TOKENS.textDark}
        lineHeight='normal'
      >
        Add New Indicator
      </Text>
    </Flex>
  );
});

AddIndicatorTableFooterV1.displayName = 'AddIndicatorTableFooterV1';

export default AddIndicatorTableFooterV1;
